import Vue from 'vue'
import Vuex from 'vuex'
import api_store from './modules/api_store'
import brand_store from './modules/brand'
import cart_store from './modules/cart_store'
import brandstore_store from './modules/store'
import collections_store from './modules/collections_store'
import context_store from './modules/context_store'
import login_store from './modules/login_store'
import notifications_store from './modules/notifications_store'
import progress_store from './modules/progress_store'
import prepared_collections_store from './modules/prepared_collections_store'
import country_language_store from './modules/country_language_store'
import colors_store from './modules/colors_store'
import initialize_store from './modules/initialize_store'
import process_store from './modules/process_store'
import combo_items_store from './modules/combo_items_store'
import customer_store from './modules/customer_store'
import tracking_store from './modules/tracking_store'
import payment_store from './modules/payment_store'
import da_store from './modules/da_store'
import store_delivery_area_map from './modules/store_delivery_area_map'
import catalog from './modules/catalog'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    api_store,
    brand_store,
    cart_store,
    brandstore_store,
    collections_store,
    context_store,
    login_store,
    notifications_store,
    progress_store,
    prepared_collections_store,
    country_language_store,
    colors_store,
    initialize_store,
    process_store,
    combo_items_store,
    customer_store,
    tracking_store,
    payment_store,
    da_store,
    store_delivery_area_map,
    catalog,
  },
})
